import { cn } from "@babybjorn/ui";
import type { FC } from "react";
import * as s from "./Badge.module.scss";

type BadgeProps = {
	labels: string[];
	vertical?: boolean;
	alignRight?: boolean;
	className?: string;
};

/**
 * Component that uses this badge need to have position: relative.
 */
const Badge: FC<BadgeProps> = ({ labels, vertical, alignRight, className }) => {
	return (
		<span
			className={cn(s.container, className, {
				[s.vertical]: vertical,
				[s.alignRight]: alignRight,
			})}
		>
			{labels.map((label, idx) => (
				<span key={`${label}-${idx}`}>{label.toUpperCase()}</span>
			))}
		</span>
	);
};

export default Badge;
